export var CastAndCrewMemberRole;
(function(CastAndCrewMemberRole) {
    CastAndCrewMemberRole[/**
     * A person who portrays a character within a [[Film]].
     */ "Actor"] = "Actor";
    CastAndCrewMemberRole[/**
     * A person who directs the making of a [[Film]].
     */ "Director"] = "Director";
    CastAndCrewMemberRole[/**
     * A person responsible for the financial or managerial aspects of a [[Film]].
     */ "Producer"] = "Producer";
})(CastAndCrewMemberRole || (CastAndCrewMemberRole = {}));

//# sourceMappingURL=cast-and-crew-member-role.js.map